import { AUTH_GET, AUTH_POST, AUTH_PUT } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const fetchExternalIntegrationMappings = createAsyncThunk("external-integration-mappings/get", async (_, { rejectWithValue }) => {
    try {
        const response = await AUTH_GET(`${config.baseURL}/api/lead-external-integration-mapping`, {
            tags: ["lead-external-integration-mapping"],
        });
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const addExternalIntegrationMapping = createAsyncThunk("external-integration-mappings/add", async (payload: any, { rejectWithValue }) => {
    try {
        const response = await AUTH_POST(`${config.baseURL}/api/lead-external-integration-mapping`, payload, {
            tags: ["lead-external-integration-mapping", "add-lead-external-integration-mapping",
                payload.source, payload.organization, payload.module, payload.sourceFieldName, payload.mapFieldName, payload.defaultValue],
        });
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const updateExternalIntegrationMapping = createAsyncThunk("external-integration-mappings/update", async (payload: any, { rejectWithValue }) => {
    try {
        const response = await AUTH_PUT(`${config.baseURL}/api/lead-external-integration-mapping/${payload._id}`, payload.values, {
            tags: ["lead-external-integration-mapping", "update-lead-external-integration-mapping",
                payload.values.source, payload.values.organization, payload.values.module, payload.values.sourceFieldName, payload.values.mapFieldName, payload.values.defaultValue],
        });
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
});

